const admins_roles_show = (state = [], action) => {
  switch (action.type) {
    case "admins_roles_store":
      return action.payload;
    default:
      return state;
  }
};

export default admins_roles_show;
